import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.css'
})
export class PageHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() icon: 'email' | 'phone' | 'search' | 'user' | 'shield' | 'certificate' | 'addon' | 'chart' = 'search';
  @Input() badgeText: string = '';
  @Input() showBadge: boolean = false;
}
